<template>
  <div class="flex">
    <div class="flex items-center justify-start py-2 mr-6" @click="changeColor">
      <div
        :class="
          post.retweet && post.retweet.length > 0
            ? 'text-green-600 flex hover:text-green-400'
            : 'text-gray-600 flex hover:text-green-400'
        "
      >
        <div
          class="w-6 h-6 hover:bg-green-200 rounded-full hover:text-green-500"
        >
          <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
            class="w-6 h-6 fill-current"
          >
            <g>
              <path
                d="M23.77 15.67c-.292-.293-.767-.293-1.06 0l-2.22 2.22V7.65c0-2.068-1.683-3.75-3.75-3.75h-5.85c-.414 0-.75.336-.75.75s.336.75.75.75h5.85c1.24 0 2.25 1.01 2.25 2.25v10.24l-2.22-2.22c-.293-.293-.768-.293-1.06 0s-.294.768 0 1.06l3.5 3.5c.145.147.337.22.53.22s.383-.072.53-.22l3.5-3.5c.294-.292.294-.767 0-1.06zm-10.66 3.28H7.26c-1.24 0-2.25-1.01-2.25-2.25V6.46l2.22 2.22c.148.147.34.22.532.22s.384-.073.53-.22c.293-.293.293-.768 0-1.06l-3.5-3.5c-.293-.294-.768-.294-1.06 0l-3.5 3.5c-.294.292-.294.767 0 1.06s.767.293 1.06 0l2.22-2.22V16.7c0 2.068 1.683 3.75 3.75 3.75h5.85c.414 0 .75-.336.75-.75s-.337-.75-.75-.75z"
              ></path>
            </g>
          </svg>
        </div>

        <span
          :class="
            post.retweet && post.retweet.length > 0
              ? 'text-green-600 flex hover:text-green-400'
              : 'text-gray-600 flex hover:text-green-400'
          "
          >{{ post.retweet_count }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
  import SvgIcon from "@jamescoyle/vue-icon";
  import { mdiDeleteForeverOutline, mdiHeart, mdiRepeatVariant } from "@mdi/js";

  export default {
    name: "RetweetButton",
    emits: ["retweet-click"],
    props: {
      id: Number,

      post: Object,
      retweetHandler: Function
    },
    components: {
      SvgIcon
    },
    data() {
      return {
        clicked: false
      };
    },
    created() {},

    methods: {
      changeColor() {
        if (this.nowGreen) {
          this.color = "text-gray-600";

          this.clicked = false;
        } else {
          this.clicked = true;

          this.color = "text-green-600";
        }

        this.retweetHandler(this.post.id);
      }
    }
  };
</script>

<style scoped lang="scss">
</style>

